<template>
    <div>
      <b-form @submit.prevent>
        <b-row>
          <!-- Status -->
          <b-col cols="3">
            <label for="status-list">Status</label>
            <b-form-select id="status-list"
                           size="sm"
                           class="mr-4"
                           @change="reload"
                           v-model="filter.status"
                           :options="options('status')"></b-form-select>
          </b-col>
          <!-- /Status -->
          <b-col cols="3"></b-col>
          <!-- Keyword -->
          <b-col cols="4">
            <div class="text-container keyword-label-area">
              <label for="Keyword">Keyword</label>
              <div class="search-toggle-area">
                <span>{{ keywordSwitchLabel }}</span>
                <b-input-group-append is-text>
                  <b-form-checkbox switch
                                   class="mr-2"
                                   v-model="filter.keywordWithComment"
                                   :value="true"
                                   :unchecked-value="false">
                  </b-form-checkbox>
                </b-input-group-append>
              </div>
            </div>
            <b-input-group size="sm">
              <b-form-input placeholder="Keyword"
                            @keyup.enter="reload"
                            v-model="filter.keyword"/>
            </b-input-group>
          </b-col>
          <!-- /Keyword -->
          <!-- Search detail button -->
          <b-col class="d-flex justify-content-end"
                 style="flex-grow: 0;">
            <b-button variant="outline-secondary"
                      @click="expandSearchDetail"
                      class="btn btn-secondary small">Search Detail
            </b-button>
          </b-col>
          <!-- /Search detail button -->
        </b-row>
      </b-form>
  
      <!-- Search detail collapse -->
      <div>
        <b-collapse id="collapse-4"
                    v-model="visible">
          <!-- Button Group -->
          <div class="btn-wrap">
            <div class="btn-group-area">
              <b-button v-if="this.queryTitle !== '' && this.query !== ''"
                        class="common-button custom-height"
                        variant="outline-primary"
                        size="sm"
                        @click="saveQuery()"><span
                v-if="this.queryId">SAVE</span><span v-else>ADD</span></b-button>
              <!-- <b-button v-if="this.queryId" class="common-button custom-height" variant="outline-primary" size="sm"
                @click="createQuery()"><span>ADD</span></b-button> -->
              <b-button class="btn btn-secondary small"
                        variant="outline-danger"
                        @click="deleteQuery()">
                <span v-if="this.queryId">Del</span><span v-else>Clear</span>
              </b-button>
              <b-button v-b-toggle.collapse-1
                        class="btn btn-secondary small"
                        variant="outline-info"
                        @click="retrieveTableInfo()"><span>Info</span></b-button>
            </div>
            <b-button class="btn btn-primary small"
                      variant="outline-primary"
                      @click="reload()"><span>Run</span></b-button>
          </div>
          <div>
            <b-collapse id="collapse-1"
                        class="mt-2">
              <b-card no-body
                      style="padding:0;">
                <!-- 테이블 정보 여기에 출력하면 될거 같음 -->
                <b-form-row>
                  <!-- 쿼리 테이블 하드코딩 -->
                  <div class="info-table-wrap">
                    <ul class="info-table">
                      <li class="column">
                        <span class="title">Column Comment</span>
                        <ul class="contents">
                          <li class="content">My Schedule ID (Ex.C00001)</li>
                          <li class="content">My Schedule 제목</li>
                          <li class="content">My Schedule 설명</li>
                          <li class="content">My Schedule 시작 일시 (Ex. YYYY-MM-DD)</li>
                          <li class="content">My Schedule 목표 일시 (Ex. YYYY-MM-DD)</li>
                          <li class="content">My Schedule 상태</li>
                          <li class="content">My Schedule 복잡도</li>
                          <li class="content">My Schedule 우선 순위</li>
                          <li class="content blank">공란</li>
                          <li class="content blank">공란</li>
                        </ul>
                      </li>
                      <li class="column">
                        <span class="title">Column Name</span>
                        <ul class="contents">
                          <li class="content">My_Schedule_ID</li>
                          <li class="content">TITLE</li>
                          <li class="content">DESCRIPTION</li>
                          <li class="content">START_DATE</li>
                          <li class="content">DUE_DATE</li>
                          <li class="content">STATUS</li>
                          <li class="content">LEVEL</li>
                          <li class="content">PRIORITY</li>
                          <li class="content">TYPE</li>
                          <li class="content">JOB</li>
                        </ul>
                      </li>
                    </ul>
                    <ul class="info-table">
                      <li class="column">
                        <span class="title">Column Comment</span>
                        <ul class="contents">
                          <li class="content">My Schedule 예상 작업 시간</li>
                          <li class="content">My Schedule 실제 작업 시간</li>
                          <li class="content blank">공란</li>
                          <li class="content blank">공란</li>
                          <li class="content blank">공란</li>
                          <li class="content blank">공란</li>
                          <li class="content blank">공란</li>
                          <li class="content blank">공란</li>
                          <li class="content">등록 사용자 ID</li>
                          <li class="content">등록 일시</li>
                          <li class="content">수정 사용자 ID</li>
                          <li class="content">수정 일시</li>
                        </ul>
                      </li>
                      <li class="column">
                        <span class="title">Column Name</span>
                        <ul class="contents">
                          <li class="content">EST_HOUR</li>
                          <li class="content">WORK_HOUR</li>
                          <li class="content">L1</li>
                          <li class="content">L2</li>
                          <li class="content">L3</li>
                          <li class="content">L4</li>
                          <li class="content">L5</li>
                          <li class="content">UNREAD</li>
                          <li class="content">CREATOR_ID</li>
                          <li class="content">CREATION_DATE</li>
                          <li class="content">UPDATER_ID</li>
                          <li class="content">UPDATED_DATE</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </b-form-row>
              </b-card>
            </b-collapse>
          </div>
          <b-row>
            <b-col cols="2">
              <b-form-select v-model="queryId"
                             :options="queryOptions"
                             value-field="id"
                             text-field="name"
                             :select-size="5"
                             @change="queryChanged"
                             class="new-query">
              </b-form-select>
            </b-col>
            <b-col cols="10">
              <b-form-input name="title"
                            label="Title"
                            placeholder="Title"
                            size="sm"
                            class="query-title"
                            v-model="queryTitle"
                            ref="title"
                            v-validate="{ required: true }"></b-form-input>
              <!-- <label for="textarea">Title</label> -->
              <b-form-textarea id="textarea"
                               v-model="query"
                               placeholder="Enter query..."></b-form-textarea>
            </b-col>
          </b-row>
        </b-collapse>
      </div>
      <!-- /Button Group -->
      <!-- TODO -->
    </div>
    <!-- /Search detail collapse -->
  </template>
  
  <script>
  export default {
    name: "MyScheduleFilter",
    computed: {
      filter() {
        return this.$store.getters['mySchedule/filter'];
      },
      firstHalfItemInfo() {
        const halfIndex = Math.ceil(this.tableInfo.length / 2);
        return this.tableInfo.slice(0, halfIndex);
      },
      secondHalfItemInfo() {
        const halfIndex = Math.ceil(this.tableInfo.length / 2);
        return this.tableInfo.slice(halfIndex);
      },
      keywordSwitchLabel() {
        return this.filter.keywordWithComment ? "With Comment" : "With Comment";
      }
    },
    data() {
      return {
        visible: false,
        queryId: null,
        query: '',
        queryTitle: '',
        queryOptions: [],
        tableInfo: [],
      }
    },
    created() {
      this.retrieveQueries();
      //this.$store.dispatch('chatter/retrieveAssigneeOptions');
      /** 23-10-11 
       * Chatter Top Bar에서 최초 dispatch 하고
       * 이후 부터는 중앙 저장소에서 가져오는 식으로 변경
       *  */ 
      //this.$store.dispatch('chatter/retrieveProjectOptions');
    },
    methods: {
      options(type) {
        let optionsObj =  this.$store.getters['mySchedule/options'][type+'Options'];
        let allOption = null;
        switch (type) {
          case 'status':
            allOption = { value: "", text: "All Status" };
            break;
        }
        return [allOption, ...optionsObj];
      },
      reload() {
        this.filter.query = this.query;
        this.$store.commit('mySchedule/setUpdated', 'N');
        this.$emit('reload')
      },
      expandSearchDetail() {
        this.visible = !this.visible;
        if (this.visible === false) {
          this.filter.query = null;
        }
      },
      queryChanged() {
        if (this.queryId == null) {
          this.queryTitle = '';
          this.query = '';
          return;
        }
        const selectedOption = this.queryOptions.find(option => option.id === this.queryId);
        this.query = selectedOption.query;
        this.queryTitle = selectedOption.name;
      },
      async retrieveQueries() {
        //todo 쿼리 리스트 조회
        let response = await axios.get("chatter/selectRetrieveQueryList", {
          params: {},
          headers: {
            Accept: "application/json",
            Authorization: accessToken(),
          },
        })
        this.queryOptions = response.data;
        this.queryOptions.unshift({ id: null, name: 'New Query', query: '' })
        this.queryTitle = '';
        this.query = '';
      },
      async deleteQuery() {
        if (this.queryId) {
          await axios.post("chatter/removeRetrieveQuery/" + this.queryId, {}, {
            headers: {
              Accept: "application/json",
              Authorization: accessToken(),
            },
          })
        } else {
          this.queryTitle = '';
          this.query = '';
          return;
        }
        // TODO 삭제 API 호출
        this.queryId = null;
        this.retrieveQueries();
      },
      async saveQuery() {
        let param = {
          query: this.query,
          name: this.queryTitle
        }
        if (this.queryId) { // Query Update
          param.id = this.queryId;
          await axios.post("chatter/updateRetrieveQuery", param, {
            headers: {
              Accept: "application/json",
              Authorization: accessToken(),
            },
          })
  
        } else { // Query Create
          await axios.post("chatter/addRetrieveQuery", param, {
            headers: {
              Accept: "application/json",
              Authorization: accessToken(),
            },
          })
        }
        this.retrieveQueries();
      },
      async retrieveTableInfo() {
        let response = await axios.get("chatter/retrieveFieldInfo", {
          params: {},
          headers: {
            Accept: "application/json",
            Authorization: accessToken(),
          },
        });
        this.tableInfo = response.data;
      }
    },
  }
  </script>
  <style>
  .text-container {
      white-space: nowrap;
      /* 텍스트가 줄바꿈되지 않도록 설정 */
      overflow: hidden;
      /* 너비를 초과하는 텍스트를 감추기 */
      text-overflow: ellipsis;
      /* 초과된 텍스트를 "..."으로 표기 */
  }
  
  /* 신규 추가 스타일 */
  /* import font */
  @import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');
  
  /* button */
  .my-schedule-list .btn {
      border-radius: 10px;
      font-family: 'NanumGothic';
      font-size: 14px;
      font-weight: 500;
      line-height: 150%;
      border: none;
  }
  
  .my-schedule-list .btn:focus {
      box-shadow: none;
  }
  
  .my-schedule-list .btn-secondary {
      width: 148px;
      height: 60px;
      border-radius: 10px;
      background: #747480;
      color: #fff;
  }
  
  .my-schedule-list .btn-secondary.small {
      height: 40px;
  }
  
  .my-schedule-list .btn-secondary:hover {
      background-color: #565662;
  }
  
  .my-schedule-list .btn-secondary.disabled,
  .my-schedule-list .btn-secondary:disabled {
      color: #9C9CA8;
      background-color: #C4C4CD;
      border-color: transparent;
  }
  
  .my-schedule-list .btn-primary {
      width: 280px;
      height: 60px;
      background-color: #2E2E38;
      color: #FFE600;
      border-color: transparent;
  }
  
  .my-schedule-list .btn-primary:hover {
      color: #FFE600;
      background-color: #0D0D17;
      border-color: transparent;
  }
  
  .my-schedule-list .btn-primary.disabled,
  .my-schedule-list .btn-primary:disabled {
      color: #9C9CA8;
      background-color: #C4C4CD;
      border-color: transparent;
  }
  
  .my-schedule-list .btn-primary.small {
      width: 148px;
      height: 40px;
  }
  
  .my-schedule-list .card-body .btn-wrap {
      display: flex;
      gap: 0 2rem;
      justify-content: end;
      margin-top: 3rem;
      margin-bottom: 1.33rem;
  }
  
  .my-schedule-list .btn-wrap .btn-group-area {
      position: relative;
      display: flex;
      gap: 0 0.666rem;
  }
  
  .my-schedule-list .btn-wrap .btn-group-area::after {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      right: -1rem;
      transform: translateY(-50%);
      width: 1px;
      height: calc(100% - 1.066rem);
      background-color: #DDDDE3;
  }
  
  /* select */
  .my-schedule-list .custom-select {
      padding: 0.533rem 0.8rem 0.533rem 1.066rem;
      height: 2.666rem;
      border-radius: 10px;
      border: 1px solid #E7E7EE;
      background-color: #F6F6FA;
      background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
      background-position: calc(100% - 12px) 9px;
      background-size: 20px 20px;
      background-repeat: no-repeat;
      font-family: 'NanumGothic';
      color: #2E2E38;
      font-size: 16px;
      font-weight: 400;
      line-height: 150%;
  }
  
  .my-schedule-list .my-schedule-list .custom-select:focus {
      border-color: #E7E7EE;
      box-shadow: unset;
  }
  
  /* new-query select */
  .my-schedule-list .custom-select.new-query {
      background-color: #FFF;
      overflow-y: hidden;
      padding: 1.066rem !important;
      min-height: 210px;
  }
  
  .my-schedule-list .custom-select.new-query:focus,
  .my-schedule-list .custom-select.new-query:checked {
      box-shadow: none;
      border: 1px solid #E7E7EE;
  }
  
  .my-schedule-list .custom-select.new-query option {
      border-radius: 5px;
      background-color: #F6F6FA;
      font-family: 'NanumGothic';
      font-size: 14px;
      font-weight: 400;
      padding: 0.466rem 0.8rem;
  }
  
  /* input */
  .my-schedule-list .label {
      padding-left: 0.4rem;
      margin-bottom: 0.53rem;
      color: #2E2E38;
      font-family: 'NanumGothic';
      font-size: 14px;
      font-weight: 700;
      line-height: 150%;
  }
  
  input.form-control,
  .my-schedule-list .input-group-sm > .form-control {
      padding: 0.533rem 0.8rem 0.533rem 1.066rem;
      height: 2.666rem !important;
      border-radius: 10px !important;
      border: 1px solid #E7E7EE;
      background-color: #F6F6FA;
      font-family: 'NanumGothic';
      color: #2E2E38;
      font-size: 16px;
      font-weight: 400;
      line-height: 150% !important;
  }
  
  input.form-control::placeholder {
      color: #AAA;
      font-family: 'NanumGothic';
      font-size: 16px;
      font-weight: 400;
      line-height: 150%;
  }
  
  /* form */
  .my-schedule-list .row {
      align-items: flex-end;
      margin-left: -0.7812vw;
      margin-right: -0.7812vw;
  }
  
  .my-schedule-list .row > .col,
  .my-schedule-list .row > [class*="col-"] {
      padding-right: 0.78125vw;
      padding-left: 0.7812vw;
  }
  
  /* keyword 영역 */
  .keyword-label-area {
      display: flex;
      justify-content: space-between;
      align-items: center;
  }
  
  .keyword-label-area span {
      color: #747480;
      font-family: 'NanumGothic';
      font-size: 12px;
      font-weight: 500;
      line-height: 150%;
  }
  
  .keyword-label-area .search-toggle-area {
      display: flex;
      align-items: center;
      gap: 0 0.533rem;
      margin-bottom: 0.5rem;
  }
  
  .search-toggle-area .input-group-append {
      position: relative;
      width: 32px;
      height: 16px;
      margin-left: 0;
  }
  
  .search-toggle-area .input-group-append .input-group-text {
      padding: 0;
      background-color: transparent;
      border: none;
  }
  
  .search-toggle-area .input-group-append .custom-switch {
      width: 100%;
      height: 100%;
      padding: 0;
      margin-right: 0 !important;
      min-height: unset;
  }
  
  .search-toggle-area .input-group-append .custom-switch .custom-control-input:focus ~ .custom-control-label::before {
      box-shadow: none;
  }
  
  .search-toggle-area .input-group-append .custom-switch .custom-control-label {
      width: 100%;
      height: 100%;
  }
  
  .search-toggle-area .input-group-append .custom-switch .custom-control-label::before {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      width: 32px;
      height: 16px;
      pointer-events: none;
      content: "";
      background-color: #E7E7EE;
      border: none;
  }
  
  .search-toggle-area .input-group-append .custom-switch .custom-control-label::after {
      top: 0;
      left: 0;
      width: 16px;
      height: 16px;
      background-color: #747480;
      border-radius: 80px;
  }
  
  .search-toggle-area .input-group-append .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
      background-color: #747480;
      transform: translateX(16px);
  }
  
  /* query 영역 */
  .my-schedule-list .query-title {
      height: auto !important;
      padding: 0 0 0 0.4rem !important;
      margin-bottom: 0.53rem;
      background-color: #FFF;
      border: none;
      border-radius: 0;
      color: #2E2E38;
      font-family: 'NanumGothic';
      font-size: 14px;
      font-weight: 700;
      line-height: 150%;
  }
  
  .my-schedule-list .query-title::placeholder {
      color: #2E2E38;
      font-family: 'NanumGothic';
      font-size: 14px;
      font-weight: 700;
      line-height: 150%;
  }
  
  .my-schedule-list .query-title:focus {
      border-color: unset;
      box-shadow: unset;
  }
  
  .my-schedule-list textarea {
      min-height: 180px;
      padding: 0.666rem 1.066rem;
      margin: 0;
      line-height: normal;
      border-radius: 10px;
      border: 1px solid #E7E7EE;
      background: #F6F6FA;
  }
  
  /* info 영역 */
  .info-table-wrap ul {
      padding-left: 0;
  }
  
  .info-table-wrap li {
      list-style: none;
  }
  
  .info-table-wrap {
      display: flex;
      flex-wrap: wrap;
      gap: 2.666rem;
      width: 100%;
      margin-bottom: 2.666rem;
      font-family: 'NanumGothic';
  }
  
  .info-table-wrap .info-table {
      display: flex;
      flex-grow: 1;
      flex-shrink: 0;
      margin-bottom: 0;
      text-decoration: none;
      border-radius: 10px;
      overflow: hidden;
      background-color: #F6F6FA;
      color: #2E2E38;
      font-size: 14px;
  }
  
  .info-table-wrap .info-table .column {
      width: 50%;
  }
  
  .info-table-wrap .info-table .column .title {
      font-weight: 700;
      line-height: 60px;
      padding-left: 1.333rem;
  }
  
  .info-table-wrap .info-table .column .contents {
      padding: 0;
  }
  
  .info-table-wrap .info-table .column .content {
      line-height: 60px;
      border-bottom: 1px solid #E7E7EE;
      padding: 0 1.333rem;
  }
  
  .info-table-wrap .info-table .column .content:last-child {
      border-bottom: 0;
  }
  
  .info-table-wrap .info-table .column .content.blank {
      font-size: 0;
  }
  </style>